import { LoadSpinner } from '@calizahq/react-components-v2'
import React, { useMemo } from 'react'

import { NoResults, Table } from '@/components'
import ListFilter, { FilterTypes } from '@/components/ListFilter/ListFilter'
import { useMobile } from '@/hooks'
import { useHomeQualityChecks } from '@/hooks/useHomeQualityChecks/useHomeQualityChecks'

import { MobileHomeQualityCheckSummaryCard } from '../Home/HomeQualityChecks/Summary/MobileHomeQualityCheckSummaryCard'
import { HomeQualityCheckListColumns } from './HomeQualityChecks.data'

export const HomeQualityChecks = () => {
  const { data: homeQualityCheckData, isLoading, refetch } = useHomeQualityChecks()

  const data = useMemo(() => {
    return homeQualityCheckData && homeQualityCheckData?.homeQualityChecks ? homeQualityCheckData.homeQualityChecks : []
  }, [homeQualityCheckData])

  const { isMobile } = useMobile()

  const columns = useMemo(() => {
    return HomeQualityCheckListColumns
  }, [])

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      <ListFilter
        hideFilters={true}
        hideLengthOfStayFilter={true}
        hideMarketSegment={false}
        hideReservationMoveInFilter={false}
        hideReservationMoveOutFilter={true}
        hideSearch={true}
        listType={FilterTypes.HOME_QUALITY_CHECKS}
        title="Home Quality Checks"
      />

      {isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isMobile ? (
            data && data?.length > 0 ? (
              data?.map((homeQualityCheck, index) => (
                <MobileHomeQualityCheckSummaryCard
                  homeQualityCheck={homeQualityCheck}
                  key={index}
                  refetchOnSuccess={refetch}
                />
              ))
            ) : (
              <NoResults />
            )
          ) : (
            <Table className={''} columns={columns as any} data={data} />
          )}
        </>
      )}
    </div>
  )
}
